(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("A11yDialog"), require("mitt"));
	else if(typeof define === 'function' && define.amd)
		define([, ], factory);
	else if(typeof exports === 'object')
		exports["A11yConsent"] = factory(require("A11yDialog"), require("mitt"));
	else
		root["A11yConsent"] = factory(root["A11yDialog"], root["mitt"]);
})(window, (__WEBPACK_EXTERNAL_MODULE__612__, __WEBPACK_EXTERNAL_MODULE__218__) => {
return 